import OapProductIngredients from './code/Scripts/components/OapProductIngredients.vue';

export default {
  components: {
    OapProductIngredients,
  },
};
